import React from "react";
import PropTypes from "prop-types";
import { Alert, Button, Modal } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { selectKycStatus, selectIdenfyError } from "../../store/user/selectors";
import { withTranslation } from "react-i18next";
import { SET_KYC_STEP } from "../../store/user/actionTypes";
const StepKycStatus = ({ t, kycStatus, onHide, idenfyError }) => {
  let dispatch = useDispatch();

  const getStatusMessage = () => {
    switch (kycStatus) {
      case "expired":
        return t("Your session has expired. Press below to try again.");
      case "rejected":
        return t(
          "We reviewed your information and decided we can't allow you to operate on our platform. If you think this is a mistake please contact support."
        );
      case "idenfyError":
        if (
          idenfyError &&
          idenfyError.code === 400 &&
          idenfyError.error_detail?.start_kyc === "KYC check already in progress for this wallet"
        )
          return t("You've already launched the KYC Process in another browser, please complete the process there.");
        return t(
          "There was an unexpected error starting KYC. Please try again later. If the issue persists, please contact support."
        );
      default:
        return;
    }
  };

  const handleTryAgain = () => {
    dispatch({ type: SET_KYC_STEP, step: "intro" });
  };

  return (
    <>
      <Alert variant={kycStatus === "rejected" || kycStatus === "idenfyError" ? "danger" : ""}>
        {getStatusMessage()}
      </Alert>
      <Modal.Footer>
        {kycStatus === "expired" || kycStatus === "idenfyError" || kycStatus === "rejected" ? (
          <Button className="align-end" variant="primary" onClick={handleTryAgain}>
            {t("Try again")}
          </Button>
        ) : (
          <Button className="align-end" variant="primary" onClick={onHide}>
            {t("Close")}
          </Button>
        )}
      </Modal.Footer>
    </>
  );
};

StepKycStatus.propTypes = {
  t: PropTypes.any,
  kycStatus: PropTypes.string,
  kycSignature: PropTypes.object,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const kycStatus = selectKycStatus(state.UserReducer);
  const idenfyError = selectIdenfyError(state.UserReducer);

  return {
    kycStatus,
    idenfyError,
  };
};

export default connect(mapStateToProps)(withTranslation()(StepKycStatus));
